export default "__VITE_ASSET__D4wVSi1___"